import React, { useState, useRef, useMemo, useEffect } from "react";
import { useHistory } from "react-router-dom";

import SweetAlert from "sweetalert2";

import api from "../../../services/api";
import { decrypt } from "../../../util/rotinas";
import Button from "../../../components/Button";
import ContentHeader from "../../../components/ContentHeader";
import Content from "../../../components/Content";
import CardHeader from "../../../components/CardHeader";
import TableGrid from "../../../components/TableGrid";
import CardFooter from "../../../components/CardFooter";
import CustomModal from "../../../components/Modal";
import ButtonCard from "../../../components/ButtonCard";

import {
  searchByAllKeys,
  sortByProperty,
  ajustaActiveClassMenu,
} from "../../../util/rotinas";
import { toast } from "react-toastify";

export default function Perfil() {
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);

  const [listPerfil, setListPerfil] = useState([]);
  const [listPerfilFiltrado, setListPerfilFiltrado] = useState([]);

  const [isModalOpen, setModalStatus] = useState(false);
  const [listAcessos, setListAcessos] = useState([]);
  const [listAcessosFiltrado, setListAcessosFiltrado] = useState([]);

  const [btnNovoPerfil, setBtnNovoPerfil] = useState(false);
  const [btnEditarPerfil, setBtnEditarPerfil] = useState(false);
  const [btnExcluirPerfil, setBtnExcluirPerfil] = useState(false);
  const [btnAcessosPerfil, setBtnAcessosPerfil] = useState(false);

  const history = useHistory();
  const searchRef = useRef(null);
  const modalRef = useRef(null);
  const searchRefAcessos = useRef(null);

  async function getPerfil() {
    setLoading(true);
    await api
      .get(`profile`)
      .then((res) => {
        setListPerfil(res.data.data);
        setListPerfilFiltrado(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  async function getAcessos(perfil_id) {
    setLoadingModal(true);
    setModalStatus(true);
    await api
      .get(`profile/getAccess?id=${perfil_id}`)
      .then((res) => {
        setListAcessos(res.data.data);
        setListAcessosFiltrado(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingModal(false);
      });
  }

  useEffect(() => {
    ajustaActiveClassMenu("conMenu", "perMenu");

    const u = decrypt(localStorage.getItem("@ipm:user"), true);
    const acessos = u?.profile?.access;

    let aList;
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "profile" &&
        a.action === "new"  &&
        a.has_access
    );
    if (aList.length !== 0) setBtnNovoPerfil(true);
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "profile" &&
        a.action === "edit"  &&
        a.has_access
    );
    if (aList.length !== 0) setBtnEditarPerfil(true);
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "profile" &&
        a.action === "delete"  &&
        a.has_access
    );
    if (aList.length !== 0) setBtnExcluirPerfil(true);
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "profile" &&
        a.action === "access"  &&
        a.has_access
    );
    if (aList.length !== 0) setBtnAcessosPerfil(true);

    getPerfil();
  }, []);

  const deletePerfil = function (obj) {
    SweetAlert.fire({
      title: "Confirma exclusão do perfil ?",
      text: `${obj?.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`/profile/${obj.id}`)
          .then(() => {
            toast.success(`Perfil excluído com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            getPerfil();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const columns = useMemo(() => [
    {
      name: "Código",
      selector: "id",
      sortable: true,
      width: "65px",
    },
    {
      name: "Descrição",
      selector: "name",
      sortable: true,
    },

    {
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          {btnAcessosPerfil ? (
            <>
              <button
                className="btn btn-warning btn-xs"
                onClick={() => getAcessos(row.id)}
              >
                Acessos
              </button>
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },

    {
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          {btnEditarPerfil ? (
            <>
              <button
                className="btn btn-default btn-xs"
                onClick={() => history.push("/profile/profile-edit/" + row.id)}
              >
                <i className="fa fa-fw fa-pencil"></i>
              </button>
            </>
          ) : null}
          {btnExcluirPerfil ? (
            <>
              <button
                onClick={() => deletePerfil(row)}
                className="btn btn-danger btn-xs"
              >
                <i className="fa fa-fw fa-trash-o"></i>
              </button>
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  function checkBoxAcessosClick(row) {
    const temp = listAcessos.map(item =>{
      if(item.id === row.id){
        return {
          ...item,
          has_access: !item.has_access
        }
      }
      return item
    })
    setListAcessos(temp)
    setListAcessosFiltrado(temp)
    // let listTmp = listAcessosFiltrado.filter((a) => a.id !== row.id);
    // let listTmpCompleta = listAcessos.filter((a) => a.id !== row.id);
    // row.acesso_ok = !row.acesso_ok;
    // listTmp.push(row);
    // listTmpCompleta.push(row);
    // listTmp.sort(sortByProperty("id", true));
    // listTmpCompleta.sort(sortByProperty("id", true));
    // setListAcessosFiltrado(listTmp);
    // setListAcessos(listTmpCompleta);
  }

  const columnsAcessos = useMemo(() => [
    {
      name: "Nome Tela",
      selector: "display_screen_name",
      sortable: true,
    },
    {
      name: "Ação",
      selector: "display_action",
      sortable: true,
    },

    {
      cell: (row) => (
        <div className="checkbox checkbox-success">
          <input
            onChange={() => checkBoxAcessosClick(row)}
            type="checkbox"
            id="checkbox1"
            className="styled"
            checked={row.has_access}
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  
  const handleSubmitAcessos = function () {
    setLoadingModal(true);
    api
      .post(`profile/setAccess`, listAcessos)
      .then(() => {
        toast.success(`Acessos atualizados com sucesso.`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingModal(false);
        setModalStatus(false);
      });
  };

  const handleClose = () => {
    setModalStatus(false);
  };

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Perfis de Acesso"
      />
      <Content>
        <CardHeader
          title={"Perfis de Acesso"}
          icon={"fa-unlock-alt"}
          searchVisible={true}
          searchRef={searchRef}
          onChange={() =>
            setListPerfilFiltrado(searchByAllKeys(listPerfil, searchRef))
          }
        />
        <TableGrid
          columns={columns}
          data={listPerfilFiltrado}
          loading={loading}
        />
        {btnNovoPerfil ? (
          <CardFooter>
            <Button
              type="button"
              title="Novo"
              onClick={() => history.push("/profile/profile-new")}
            />
          </CardFooter>
        ) : null}
      </Content>

      <CustomModal
        id="modalTeste"
        open={isModalOpen}
        close={handleClose}
        modalRef={modalRef}
      >
        <form>
          <Content>
            <CardHeader
              title={"Acessossss"}
              icon={"fa-unlock-alt"}
              searchVisible={true}
              searchRef={searchRefAcessos}
              onChange={() =>
                setListAcessosFiltrado(
                  searchByAllKeys(listAcessos, searchRefAcessos)
                )
              }
            />
            <TableGrid
              columns={columnsAcessos}
              data={listAcessosFiltrado}
              loading={loadingModal}
              paginationPerPage={5}
              notPerPage
            />
          </Content>
        </form>

        <div className="col-lg-12" style={{ padding: "0" }}>
          <div className="row">
            <div className="col-lg-6 col-6">
              <ButtonCard
                className="small-box bg-info"
                onClick={handleSubmitAcessos}
                title="Salvar"
              />
            </div>
            <div className="col-lg-6 col-6">
              <ButtonCard
                className="small-box bg-danger"
                onClick={handleClose}
                title="Cancelar"
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
